import { zodResolver } from "@hookform/resolvers/zod";
import { useWasteStationList } from "api/wasteStation.api";
import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { TransportSedel } from "types/transportSedel.type";
import { z } from "zod";
import { usePatchTransportSedelSheet } from "./usePatchTransportSedelSheet";

const wasteStationSchema = z.object({
  wasteStationUuid: z
    .string({
      required_error: "Obligatoriskt fält",
      message: "Obligatoriskt fält",
    })
    .uuid(),
});
type TWasteStationSchema = z.infer<typeof wasteStationSchema>;

export const useUpdateWasteStationLogic = (transportSedel: TransportSedel) => {
  const sheet = usePatchTransportSedelSheet();

  const form = useForm<TWasteStationSchema>({
    resolver: zodResolver(wasteStationSchema),
    defaultValues: {
      wasteStationUuid: transportSedel.wasteStation?.uuid,
    },
  });

  useEffect(() => {
    if (sheet.isModalOpen) {
      form.reset({ wasteStationUuid: transportSedel.wasteStation?.uuid });
    }
  }, [form, transportSedel, sheet.isModalOpen]);

  const onSubmit = form.handleSubmit((data: TWasteStationSchema) => {
    sheet.mutation.mutate({
      id: transportSedel.id,
      payload: { wasteStationUuid: data.wasteStationUuid },
    });
  });

  const { data: wasteStations } = useWasteStationList();
  const wasteStationDropdownItems = useMemo(
    () =>
      (wasteStations ?? [])
        .map((x) => ({ label: x.name, value: x.uuid }))
        .sort((a, b) => (a.label < b.label ? -1 : 1)),
    [wasteStations],
  );

  return {
    isModalOpen: sheet.isModalOpen,
    openModal: sheet.openModal,
    onModalClose: sheet.onModalClose,
    form,
    onSubmit,
    isPending: sheet.mutation.isPending,
    wasteStationDropdownItems,
  };
};

export type UpdateWasteStationLogicRetVal = ReturnType<
  typeof useUpdateWasteStationLogic
>;
